import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "src/components/dialogue/radix-dialog";
import EditHealthReportForm from "./edit-health-report-form";
import { HealthReport } from "src/redux/types/_customer.type";
import { Stethoscope } from "lucide-react";

const EditHealthReportDialog = ({
  report,
  memberId,
  open,
  close,
}: {
  report: HealthReport;
  memberId: number;
  open: boolean;
  close: () => void;
}) => {
  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="bg-white min-w-5xl max-w-5xl">
        <DialogHeader>
          <DialogTitle className="text-center">
            <h2 className="font-medium text-[#42679e] text-xl border-b flex items-center justify-center gap-3">
              <Stethoscope size={20} /> <span>Edit Health Report</span>
            </h2>
          </DialogTitle>
        </DialogHeader>
        <EditHealthReportForm report={report} memberId={memberId} close={close}/>
      </DialogContent>
    </Dialog>
  );
};

export default EditHealthReportDialog;
